import "../styles/HowItWorks.css";
import {Badge} from "./Badge";
import * as React from "react";
import {BenefitItem} from "./BenefitItem";
import {Config} from "../Config";
import {ToolIcons} from "./Tool";

export function HowItWorks(props) {
    return <div className="how-it-works section scroll-zoom-out" id={Config.PageSections.HowItWorks}>
        <Badge className={"center animate-from-bottom"}>How it works</Badge>
        <h2 className={"animate-from-bottom delay-1"}>
            From idea to interface.<br/>
            No long processes. Just smart ones.
        </h2>
        <p className="subtitle animate-from-bottom delay-2">
            No 6-month timelines. No confusing handoffs. Just focused collaboration, design that makes sense, and websites you’re proud to launch.
        </p>
        <div className="benefit-items animate-from-bottom delay-3">
            <BenefitItem icon={ToolIcons.Phone}      heading={"Discovery Call"}>Let’s align our visions. We hop on a short call to understand your business, audience, goals, and where design fits into the big picture. You’ll get strategic input, not a sales pitch.</BenefitItem>
            <BenefitItem icon={ToolIcons.Diamond}    heading={"Strategy & Design"}>Before any pixels are pushed, we define the structure and direction of your website. Then we jump into design with Figma as our playground. You’ll see early iterations and stay involved in feedback.</BenefitItem>
            <BenefitItem icon={ToolIcons.Rocket}     heading={"Build or Handoff"}>If you’re using Framer, we build the site for you — responsive, animated, and ready to ship. Prefer a custom-coded solution instead? We’ve got you covered. Just ask for a custom quote.</BenefitItem>
        </div>
    </div>;
}
